import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '@app/@core/entities/app-constants';
import { DataStoreService } from '@app/@core/services/data-store.service';
import { ProfileService } from '@app/shared/modules/profile/profile.service';
import { CommonService } from '@app/shared/services/common.service';
import { AuthState } from '@core/auth/auth.models';
import { selectAuth } from '@core/auth/auth.selectors';
import { AppState } from '@core/core.state';
import { AlertService } from '@core/services/alert.service';
import { AuthService } from '@core/services/auth.service';
import { LocalService } from '@core/services/local.service';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {
  isAuthenticated$!: Observable<AuthState>;
  localstorage: LocalService;
  constructor(
    injector: Injector,
    private store$: Store<AppState>,
    private _router: Router,
    private alertService: AlertService,
    private authService: AuthService,
    private profileService: ProfileService,
    private dataStoreService:DataStoreService,
    private commonService: CommonService
  ) {
    this.localstorage = injector.get<LocalService>(LocalService);
  }

  ngOnInit(): void {
    sessionStorage.clear();
    this.localstorage.clear();
    localStorage.clear();
    this.getSessionDetails();
    //assuming this component is entrycomponent for azure
    this.dataStoreService.setData('cloud','azure');
    this.isAuthenticated$ = this.store$.pipe(select(selectAuth));
    this.isAuthenticated$.subscribe(
      res => {
        if (res.isAuthenticated) {
          const routeToAdmin = res.pages.some(a => a.name === 'Application Management');
          if (routeToAdmin) {
            this._router.navigate(['/pages/rbac']);
          } else {
            this._router.navigate(['/pages/page-design/list']);
          }
        }
      },
      err => {
        console.log(err);

        if (err.error) {
          if (err?.error?.errors?.code === 'NotAuthorizedException' || err?.error?.errors?.email === 'notFound') {
            this.alertService.error('Invalid Credentials');
          } else this.alertService.error('System Error, Please try after sometime');
        }
      }
    );
  }

// getSessionDetails() {
  //   const getToken = window.location.hash;
  //   if (getToken.includes('#state=')) {
  //     const currentUrl = new URL(window.location.href.replace(/#/g, '?'));
  //     const stateKey = currentUrl.searchParams.get('state');
  //     const authCode = currentUrl.searchParams.get('code');
  //     const token = currentUrl.searchParams.get('id_token');
  //     const requestObject = {
  //       key: stateKey,
  //       code: authCode
  //     };
  //     this.authService.validateToken(token, requestObject).subscribe(
  //       res => {
  //         if (res) {
  //           this.getUserInfo();
  //         }
  //       },
  //       error => {
  //         const errorDetails = error?.error;

  //         if (!errorDetails) {
  //           return;
  //         }

  //         if (this.isUnauthorizedError(errorDetails) || this.isEmailNotFoundError(errorDetails)) {
  //           this.alertService.error(AppConstants.regexEmail);
  //         } else if (this.isAccessDeniedError(errorDetails)) {
  //           this.handleAccessDeniedError(token);
  //         } else {
  //           this.handleUnexpectedError(errorDetails);
  //         }
  //       }
  //     );
  //   } else {
  //     this.generateLoginUrl();
  //   }
  // }
  // getSessionDetails(): void {
  //   const getToken = window.location.hash;
  //   if (getToken.includes('#state=')) {
  //     const currentUrl = new URL(window.location.href.replace(/#/g, '?'));
  //     const stateKey = currentUrl.searchParams.get('state');
  //     const authCode = currentUrl.searchParams.get('code');
  //     const token = currentUrl.searchParams.get('id_token');
  //     const requestObject = {
  //       key: stateKey,
  //       code: authCode
  //     };
  //     this.authService.setCookie({ token: token, cookieName: 'jwt-token' }).subscribe(resp => {
  //       if (resp) {
  //     //this.authService.validateToken(token ?? '', requestObject).subscribe(
  //       this.authService.validateToken(token, requestObject).subscribe(
  //       res => {
  //         if (res) {
  //           this.getUserInfo();
  //         }
  //       },
  //       error => {
  //         const errorDetails = error?.error;

  //         if (!errorDetails) {
  //           return;
  //         }

  //         if (this.isUnauthorizedError(errorDetails) || this.isEmailNotFoundError(errorDetails)) {
  //               // this.alertService.error(AppConstants.REGEX_EMAIL);
  //                this.alertService.error(AppConstants.regexEmail);
  //         } else if (this.isAccessDeniedError(errorDetails)) {
  //           this.handleAccessDeniedError(token);
  //         } else {
  //           this.handleUnexpectedError(errorDetails);
  //         }
  //       }
  //     );
  //      }
  //    });
  //   } else {
  //     this.generateLoginUrl();
  //   }
  // }

  getSessionDetails(): void {
  const getToken = window.location.hash;

  if (getToken.includes('#state=')) {

    const currentUrl = new URL(window.location.href.replace(/#/g, '?'));

    const stateKey = currentUrl.searchParams.get('state');
    const authCode = currentUrl.searchParams.get('code');
    const token = currentUrl.searchParams.get('id_token');

    const requestObject = {
      key: stateKey,
      code: authCode
    };

    this.authService
      .setCookie({
        token: token,
        cookieName: 'jwt-token'
      })
      .pipe(
        switchMap((resp) => {

          if (!resp) {
            throw new Error('Cookie setting failed');
          }

          // // Optional verification
          // const cookieExists = document.cookie.includes('jwt-token');

          // if (!cookieExists) {
          //   throw new Error('Cookie not available yet');
          // }

          return this.authService.validateToken(
            token ?? '',
            requestObject
          );
        })
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.getUserInfo();
            //this.authService.preloadSupportingDocumentLookups();
          }
        },

        error: (error) => {

          const errorDetails = error?.error || error;

          if (!errorDetails) {
            return;
          }

          if (
            this.isUnauthorizedError(errorDetails) ||
            this.isEmailNotFoundError(errorDetails)
          ) {

            this.alertService.error(AppConstants.regexEmail);

          } else if (this.isAccessDeniedError(errorDetails)) {

            this.handleAccessDeniedError(token);

          } else {

            this.handleUnexpectedError(errorDetails);
          }
        }
      });

  } else {

    this.generateLoginUrl();
  }
}

  generateLoginUrl() {
    this.authService.generateLoginUrl().subscribe((res: any) => {
      window.open(res?.data, '_self');
    });
  }

  private isUnauthorizedError(errorDetails: any): boolean {
    return errorDetails?.errors?.code === 'NotAuthorizedException';
  }

  private isEmailNotFoundError(errorDetails: any): boolean {
    return errorDetails?.errors?.email === 'notFound';
  }

  private isAccessDeniedError(errorDetails: any): boolean {
    return errorDetails.message?.includes(AppConstants.accessDeniedMessage);
  }

  private handleAccessDeniedError(token: string): void {
    //sessionStorage.setItem('jwt-token', token);
    // sessionStorage.setItem('jwt-token', token);
    this.localstorage.setItem('jwt-token', token);
    const sessionInfo = this.authService.getTokenDetails();
    this.localstorage.setItem('email', sessionInfo['emails'][0]);

    this.authService.resetLoggedIn().subscribe((res: any) => {
      if (res.data) {
        setTimeout(() => {
          window.location.href = res.data.logoutURL;
          this.localstorage.clear();
        }, 3000);
        this.alertService.error(AppConstants.accessDeniedMessage);
      } else {
        console.error('Unable to create logout URL');
      }
    });
  }

  private handleUnexpectedError(errorDetails: any): void {
    const errorMessage = errorDetails?.error || AppConstants.errorMessage;
    this.alertService.error(errorMessage);
  }

  getUserInfo() {
    this.authService.getAuthMe().subscribe(
      (res: any) => {
        if (res.data) {
          this.localstorage.setItem('orgid', res.data.organizationid);
          this.authService.getUserRole(res.data.id).subscribe(userInfo => {
            if (userInfo) {
              this.profileService.setUserPreference();
              this.localstorage.setItem('user', JSON.stringify(userInfo.data));
             // sessionStorage.setItem('user',JSON.stringify(userInfo.data));
              sessionStorage.setItem('user',JSON.stringify(userInfo.data));
              this.commonService.setUserData(userInfo.data);
              this.commonService.setApplicationState({ orgid: res.data.organizationid });
              const landingPage = userInfo.data.userroles[0].defaultpage;
              this.routeToDynamicPage(landingPage);
            }
          });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  routeToDynamicPage(landingPage: any) {
    const orgid = this.localstorage.getItem('orgid');
    let gridPageRoute : string ='';
    if (landingPage.route.includes('dynamic-search/search') || landingPage.route.includes('dynamic-grid/search')) {
      const pageId = landingPage.route.split('/')[4];
      if (pageId) {
        this.authService.checkDynamicPagePermission(pageId);
      } else {
        this.authService.routeToDynamicPage(orgid).subscribe(res => {
          if (res && res.data.length) {
            const authorisedPages = res?.data?.filter(a => a?.activeVersion?.gridconfig);
            this.localstorage.setItem('selectedDynamicPage', authorisedPages[0]?.activeVersion?.id);
            if (authorisedPages && authorisedPages.length && authorisedPages[0]?.activeVersion?.gridconfig) {
              if(landingPage.routing.includes('dynamic-search/search')) {
                gridPageRoute = `pages/dynamic-search/search/${authorisedPages[0]?.activeVersion?.id}`;
              } 
              if(landingPage.route.includes('dynamic-grid/search')) {
                gridPageRoute = `pages/dynamic-grid/search/${authorisedPages[0]?.activeVersion?.id}`;
              }
              this._router.navigate([gridPageRoute]);
              this.localstorage.setItem('dashboardRoute', gridPageRoute);
            }
          } else {
            this.alertService.error(
              "You don't have permissions to perform the following operations .Please Contact Administrator"
            );
          }
        });
      }
    } else {
      const landingPageRoute = `pages${landingPage?.route}`;
      const navigationExtras = landingPageRoute === 'pages/my-app'? { state: { fromLogin: true } }: {};
      this._router.navigate([landingPageRoute], navigationExtras);
      this.localstorage.setItem('dashboardRoute', landingPageRoute);
    }
  }
}
